import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import moment from "moment";
import {FileManagementState, MedicalRecordState} from "src/base/Enums";
import { DI, Injector } from "src/base/Injector";
import Modal from "src/components/modal/modal";
import { Strings } from "src/constants";

import { Modals } from "src/helpers";
import {MFile} from "../../features/medicalRecord/data/models/file";
import {MedicalField} from "../../features/medicalRecord/data/models/attribute";
import {ListGalerry} from "../listGalerry";
import {IRootState} from "../../store";
import {changeModal} from "../../features/root/presenter/store/root";
import {DragDropContext} from "react-beautiful-dnd";
import DatePicker from "react-datepicker";
import {Table} from "../table";
import ImgWrapper from "../listGalerry/imgWrapper";
import {MedicalRecordContainer} from "../../features/medicalRecord/presenter/container/medicalRecordContainer";

interface ImageComparePopupProps {
    isOpen: boolean;
    onClose: () => void;
    images?: MFile[];
    listGalerry?: Array<MedicalField>;
}

interface ImageComparePopupState {
    selectedImages: Array<{
        image: any;
        imageUrl: string;
        imageLabel: string;
        imageType: string;
    }>;
    currentScreen: 'screen1' | 'screen2' | 'screen3';
    screenHistory: Array<'screen1' | 'screen2' | 'screen3'>;
    dateOrder: 'asc' | 'desc';
    fromDate?: Date;
    toDate?: Date;
    imageList?: any[];
    selectedRecords: number[];
    isLoading: boolean;
}

class ImageComparePopup extends React.Component<ImageComparePopupType, ImageComparePopupState> {

    constructor(props: ImageComparePopupType) {
        super(props);
        this.state = {
            selectedImages: [],
            currentScreen: 'screen1',
            screenHistory: ['screen1'],
            dateOrder: 'asc',
            imageList: [],
            selectedRecords: [],
            isLoading: false,
        };
    }
    resetModalState = () => {
        this.setState({
            selectedImages: [],
            currentScreen: 'screen1',
            screenHistory: ['screen1'],
            dateOrder: 'asc',
            fromDate: undefined,
            toDate: undefined,
            imageList: [],
            selectedRecords: [],
            isLoading: false,
        });
    };

    navigateToScreen = (screen: 'screen1' | 'screen2' | 'screen3') => {
        this.setState(prevState => ({
            currentScreen: screen,
            screenHistory: [...prevState.screenHistory, screen]
        }));

        if (screen !== 'screen3') {
            this.setState({ selectedRecords: [] });
        }
    };

    handleItemSelect = async (image: any) => {
        this.setState({ isLoading: true });
        try {
            const response = await this.props.fetchImageHistoryRecord(image.id);

            const formattedRecords = response.map((item: any) => ({
                id: item.id,
                created_at: item.created_at,
                name: item.title,
                label: item.path,
                image_type: item.image_type,
                path: item.path
            }));

            this.setState({
                imageList: formattedRecords,
                isLoading: false
            }, () => {
                this.navigateToScreen('screen2');
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    handleDateOrderChange = () => {
        this.setState(prevState => ({
            dateOrder: prevState.dateOrder === 'asc' ? 'desc' : 'asc'
        }));
    }

    handleRecordSelect = (recordId: number, isChecked: boolean) => {
        this.setState(prevState => {
            const selectedRecords = isChecked
                ? [...prevState.selectedRecords, recordId]
                : prevState.selectedRecords.filter(id => id !== recordId);

            return { selectedRecords };
        });
    };

    handleSelectAll = (isChecked: boolean) => {
        this.setState(prevState => {
            const selectedRecords = isChecked
                ? (prevState.imageList?.map(record => record.id) || [])
                : [];

            return { selectedRecords };
        });
    };

    getFilteredAndSortedImageList = () => {
        let filteredList = this.state.imageList || [];

        if (this.state.fromDate || this.state.toDate) {
            filteredList = filteredList.filter(record => {
                const recordDate = new Date(record.created_at);

                if (this.state.fromDate && recordDate < this.state.fromDate) {
                    return false;
                }

                if (this.state.toDate) {
                    const toDateEnd = new Date(this.state.toDate);
                    toDateEnd.setHours(23, 59, 59, 999);
                    if (recordDate > toDateEnd) {
                        return false;
                    }
                }

                return true;
            });
        }

        filteredList.sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();

            return this.state.dateOrder === 'asc' ? dateA - dateB : dateB - dateA;
        });

        return filteredList;
    };

    renderScreenContent = () => {
        const { currentScreen } = this.state;

        switch (currentScreen) {
            case 'screen1':
                return this.renderScreen1();
            case 'screen2':
                return this.renderScreen2();
            case 'screen3':
                return this.renderScreen3();
            default:
                return this.renderScreen1();
        }
    };

    renderScreen1 = () => (
        <div>
            <h4 className="text_center overflow">
                <p>比較する画像を選択してください</p>
            </h4>
            <div className="title d-xl-flex">
                <p>{Strings.IMAGE_INSIDE}</p>
            </div>
            <div className="listImages showImages">
                <ListGalerry
                    images={this.props.images}
                    listGalerry={this.props.listGalerry}
                    onChange={() => {}}
                    isDragAndDrop={false}
                    isSharedDisplay={false}
                    isCompare={true}
                    onIsCompare={this.handleItemSelect}
                />
            </div>
        </div>
    );

    renderScreen2 = () => (
        <div>
            <h4 className="text_center overflow">
                <p>比較する日時を選択してください</p>
            </h4>

            <div style={{width: '80%', margin: '0 auto'}}>
                <Table
                    className="dataTable-container-scroll dataTable-container mt-4"
                    subClassName="dataTable-table"
                    headers={[
                        {
                            fields: [
                                {
                                    html: (
                                        <div className="compare_table_checkbox">
                                            <input
                                                type="checkbox"
                                                style={{
                                                    transform: 'scale(1.5)',
                                                    transformOrigin: 'center'
                                                }}
                                                checked={
                                                    (this.state.imageList?.length || 0) > 0 &&
                                                    this.state.selectedRecords.length === (this.state.imageList?.length || 0)
                                                }
                                                onChange={(e) => {
                                                    this.handleSelectAll(e.target.checked);
                                                }}
                                            />
                                        </div>
                                    ),
                                    className: "text-center"
                                },
                                {
                                    html: (
                                        <div className="fsc datepick">
                                            <div className="input-group date" id="datetimepicker1">
                                                <DatePicker
                                                    dateFormat={"yyyy/MM/dd"}
                                                    className="form-control"
                                                    selected={this.state.fromDate}
                                                    onChange={(date) => {
                                                        let fromDate = date;
                                                        let toDate = this.state.toDate;
                                                        if (fromDate && toDate && fromDate?.getTime() >= (toDate?.getTime() ?? 0)) {
                                                            toDate = fromDate;
                                                        }
                                                        this.setState({
                                                            fromDate: fromDate ?? undefined,
                                                            toDate: toDate,
                                                            selectedRecords: [],
                                                        });
                                                    }}
                                                />
                                                <span className="input-group-addon">
                        <span className="glyphicon glyphicon-calendar"></span>
                      </span>
                                            </div>
                                            <span>～</span>
                                            <div className="input-group date" id="datetimepicker2">
                                                <DatePicker
                                                    dateFormat={"yyyy/MM/dd"}
                                                    className="form-control"
                                                    selected={this.state.toDate}
                                                    onChange={(date) => {
                                                        let fromDate = this.state.fromDate;
                                                        let toDate = date;
                                                        if (fromDate && toDate && fromDate?.getTime() >= (toDate?.getTime() ?? 0)) {
                                                            fromDate = toDate;
                                                        }
                                                        this.setState({
                                                            fromDate: fromDate,
                                                            toDate: toDate ?? undefined,
                                                            selectedRecords: [],
                                                        });
                                                    }}
                                                />
                                                <span className="input-group-addon">
                        <span className="glyphicon glyphicon-calendar"/>
                      </span>
                                            </div>
                                            {this.state.dateOrder === "asc" && (
                                                <span style={{cursor: "pointer"}} onClick={this.handleDateOrderChange}>
                        ▲
                      </span>
                                            )}
                                            {this.state.dateOrder === "desc" && (
                                                <span style={{cursor: "pointer"}} onClick={this.handleDateOrderChange}>
                        ▼
                      </span>
                                            )}
                                        </div>
                                    ),
                                },
                                {html: Strings.IMAGE_INSIDE},
                            ],
                        },
                    ]}
                    rows={this.getFilteredAndSortedImageList().map((record: any) => {
                        return {
                            fields: [
                                {
                                    html: (
                                        <input
                                            type="checkbox"
                                            style={{
                                                transform: 'scale(1.5)',
                                                transformOrigin: 'center'
                                            }}
                                            checked={this.state.selectedRecords.includes(record.id)}
                                            onChange={(e) => {
                                                this.handleRecordSelect(record.id, e.target.checked);
                                            }}
                                        />
                                    )
                                },
                                {html: moment(record.created_at).format('YYYY/MM/DD HH:mm:ss')},
                                {html: record.name},
                            ],
                        };
                    })}>
                </Table>
            </div>

            <div className="navigation-buttons"
                 style={{marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center'}}>
                <button
                    className="btn btn-primary"
                    onClick={() => this.navigateToScreen('screen3')}
                >
                    選択した画像を比較する
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => this.navigateToScreen('screen1')}
                >
                    選択画面に戻る
                </button>
            </div>
        </div>
    );

    renderScreen3 = () => {
        const selectedImageRecords = this.state.imageList?.filter(record =>
            this.state.selectedRecords.includes(record.id)
        ) || [];

        return (
            <div>
                <h4 className="text_center overflow">
                    <strong>画像比較</strong>
                </h4>

                {selectedImageRecords.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>比較する画像が選択されていません。</p>
                    </div>
                ) : (
                    <div className="image-compare-grid">
                        {selectedImageRecords.map((record, index) => (
                            <div key={record.id} style={{textAlign: 'center'}}>
                                <ImgWrapper
                                    imgURL={record.path}
                                    label={moment(record.created_at).format('YYYY.MM.DD HH:mm:ss')}
                                    readonly={true}
                                    isDragAndDrop={false}
                                    isFileDroppable={false}
                                    isSharedDisplay={false}
                                    isCompare={false}
                                    onChange={() => {
                                    }}
                                    className="col-12 img-wrapper"
                                />
                            </div>
                        ))}
                    </div>
                )}

                <div className="navigation-buttons" style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                    <button
                        className="btn btn-secondary"
                        onClick={() => this.navigateToScreen('screen2')}
                    >
                        戻る
                    </button>
                </div>
            </div>
        );
    };


    render() {
        return (
            <Modal
                id="file-management-rename-popup"
                dialogExtraClassName="file-management-popup"
                isShow={this.props.isOpen}
                onClose={() => {
                    this.resetModalState();
                    this.props.onClose();
                }}            >
                <DragDropContext onDragEnd={() => {}}>
                    {this.renderScreenContent()}
                </DragDropContext>
            </Modal>
        );
    }
}

const mapStateToProps = ({ app, medicalRecord }: IRootState) => {
    const { currentModal } = app;
    return {
        currentModal,
    };
};

const mapDispatcherToProps = (dispatch: Dispatch) => {
    return {
        changeModal: (modal: Modals) => dispatch(changeModal(modal)),
        fetchImageHistoryRecord: (imageId: string) =>
            Injector.get().find<MedicalRecordContainer>("MedicalRecordContainer").fetchImageHistoryRecord(imageId),
    };
};

type ImageComparePopupType = ImageComparePopupProps &
    ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatcherToProps>;

export default connect(mapStateToProps, mapDispatcherToProps)(ImageComparePopup);